// Delayed scripts can execute after DOMContentLoaded has already fired.
export function onDocumentReady(callback) {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", callback, { once: true });
	} else {
		// Finish evaluating the bundle before calling initializers it declares.
		Promise.resolve().then(callback);
	}
}
